<template>
  <div>
    <v-progress-linear
      v-if="!getRegistrations"
      indeterminate
      color="#006CA1"
      class="mt-3"
      style="top: -20px"
    ></v-progress-linear>
    <div class="devices-wrapper">
      <registrations-table-index class="pt-1 pb-3 registration-table" />
    </div>
    <v-tooltip top v-if="hasRoles(constants.CREATE_REGISTRATION_ROLES)">
      <template v-slot:activator="{ on, attrs }" class="create-registration-button">
        <v-btn
          color="#487A7B"
          @click="$router.push({ name: 'Create registration' })"
          dark
          fab
          bottom
          fixed
          right
          depressed
          v-bind="attrs"
          v-on="on"
        >
          <v-icon large class="create-registration-button">fa-thin fa-plus</v-icon>
        </v-btn>
      </template>
      <span>Create registration</span>
    </v-tooltip>
  </div>
</template>

<script>
import RegistrationsTableIndex from "@/components/registrations/registrations-table/table-index/registrations-table-index.vue";
import TooltipComponent from "@/components/global/tooltip-component.vue";
import { mapGetters } from "vuex";
import * as constants from "@/config/constants";

export default {
  components: {
    RegistrationsTableIndex,
    TooltipComponent,
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
  },
  computed: {
    constants() {
      return constants;
    },
    ...mapGetters(["getRegistrations", "getRoles"]),
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

.devices-wrapper {
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

@media (min-width: 768px) {
  .devices-wrapper {
    padding-top: 0px;
  }
}

.registration-table {
  max-width: unset;
}

@media only screen and (max-width: 960px) {
  ::v-deep .v-btn--fab.v-size--default {
    height: 40px;
    width: 40px;
  }

  .create-registration-button {
    font-size: 1.7rem !important;
  }
}
// .v-sheet.v-card {
//   box-shadow: none !important;
// }
</style>
